import { percentageFieldDefaults } from '../../utils/percentageMetrics'
import {
  getFormValidationMessage,
  getRequestData
} from '../../utils/newHeatMapUtil'
import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import ApiCalls from '../../../../common/ApiCalls'
import { HMapPanels } from '../../const/HMapPanels'
import HMapDetailsFooter from './HMapDetailsFooter'
import { useHMapContext } from '../../hooks/useHMapContext'
import HMapDetailsEditPanelContent from './HMapDetailsEditPanelContent'
import { getMetricsFieldsFromData } from '../../utils/heatmapFields'

const getFormFieldsFromData = (map, metrics, operationsRef, dynamicFields) => {
  return {
    ...(map.name && { name: map.name }),
    ...(map.description && { description: map.description }),
    ...(map.type && { heatmapType: map.type }),
    ...(metrics && getMetricsFieldsFromData(
      metrics,
      operationsRef.current,
      dynamicFields
    ))
  }
}

const HMapDetailsEditPanel = ({
  setCurrentPanel,
  operation,
}) => {
  const classes = useStyles()
  const [isLoading, setIsLoading] = useState(true)

  const {
    mapForEditRef,
    allHeatMapsList,
    dynamicFieldsRef,
    userIdRef,
    operationsRef,
    currentHeatmapType,
    currentMapInfo,
    snackbar,
    modal
  } = useHMapContext()

  const [modalPropsRef, setModalOpen] = modal
  const [isSnackbarOpen, setIsSnackbarOpen] = snackbar
  const userId = userIdRef.current
  const [heatmapType] = currentHeatmapType
  const [allHeatMaps, setAllHeatMaps] = allHeatMapsList
  const [currentMap, setCurrentMap,] = currentMapInfo
  const [formFields, setFormFields] = useState({
    heatmapType: heatmapType,
    name: '',
    description: '',
    userId: userId,
    numberSlider: [],
    sizeSlider: [0, 25, 50, 75, 100],
    colorSlider: [0, 35, 100],
    colorHexes: ['#549FF5', '#1DBE1D', '#FDD71A', '#ED1C24'],
    shadowSlider: [0, 35, 65, 100]
  })

  const goToTabPanel = () => setCurrentPanel(HMapPanels.HMapDisplay)

  const handleOnChange = (e) => {
    const fieldName = e.target.name
    const fieldValue = e.target.value
    const fieldLabel = e.target.text

    setFormFields({
      ...formFields,
      [fieldName]: fieldValue,
      ...percentageFieldDefaults(fieldName, fieldValue, formFields, dynamicFieldsRef.current),
      ...(!!fieldLabel && { [`${fieldName}Label`]: fieldLabel })
    })
  }

  const updateTheMapInTheList = (mapId, requestData) => {
    if (!mapId) return console.log('no MapId')

    if (mapId) {
      setAllHeatMaps([
        ...allHeatMaps.map((item) => {
          return item.id === mapId
            ? {
                ...item,
                name: requestData.name,
                description: requestData.description,
                metrics: [...requestData.metrics]
              }
            : { ...item }
        })
      ])

      if (currentMap === mapId){
        setCurrentMap((prev) => '')
        setCurrentMap((prev) => mapId)
      }
    }
  }

  const updateHeatmapInDB = (id, requestData) => {
    // Update Heatmap
    console.log(requestData)
    ApiCalls()
      .updateAHeatmap(id, requestData)
      .then((res) => {
        console.log('Update RES =>', res)
        // Snackbar
        setIsSnackbarOpen({
          ...isSnackbarOpen,
          message: 'You updated the heatmap successfully',
          severity: 'success',
          isOpen: true
        })

        setModalOpen(false)
        // const mapId = res?.data?.data?.id || undefined
        updateTheMapInTheList(id, requestData)
        goToTabPanel()
      })
      .catch((err) => {
        console.log('Update error =>', err)
        // Snackbar
        setIsSnackbarOpen({
          ...isSnackbarOpen,
          message: err.message,
          severity: 'fail',
          isOpen: true
        })

        setModalOpen(false)
      })
  }

  const submitHeatMap = (e) => {
    e.preventDefault()
    const id = mapForEditRef.current
    const validationMessage = getFormValidationMessage(formFields, dynamicFieldsRef.current)
    if (!validationMessage) {
      const requestData = getRequestData(formFields)

      modalPropsRef.current = {
        ...modalPropsRef.current,
        type: 'save',
        messageText: `Are you sure about saving the heatmap?`,
        confirmFunction: () => updateHeatmapInDB(id, requestData)
      }
      setModalOpen(true)
    } else {
      // Snackbar (error)
      setIsSnackbarOpen({
        ...isSnackbarOpen,
        message: validationMessage,
        severity: 'fail',
        isOpen: true
      })
    }
  }

  useEffect(() => {
    // load data-set form fields - bind the panel
    const id = mapForEditRef.current
    const currentMapArray = allHeatMaps.filter((item) => item.id === id)
    const currentMap = currentMapArray?.length && currentMapArray[0]

    if (currentMap) {
      // Set form defaults for metrics
      if (currentMap.metrics) {
        setFormFields({
          ...formFields,
          ...getFormFieldsFromData(
            currentMap,
            currentMap.metrics,
            operationsRef,
            dynamicFieldsRef.current
          )
        })

        setIsLoading(false)

        return
      }

      ApiCalls()
        .getAHeatmap(id)
        .then((res) => {
          const data = res?.data?.data
          const metrics = data?.metrics

          if (metrics) {
            setAllHeatMaps([
              ...allHeatMaps.map((item) =>
                item.id === id
                  ? { ...item, metrics: [...metrics] }
                  : { ...item }
              )
            ])

            // Set form defaults for the name and description
            setFormFields({
              ...formFields,
              ...getFormFieldsFromData(
                currentMap,
                metrics,
                operationsRef,
                dynamicFieldsRef.current
              )
            })

            setIsLoading(false)
          }
          console.log('metrics => ', metrics)
        })
        .catch((err) => console.log(err))
    }

    // XXX Fix this in the future
    // eslint-disable-next-line
  }, [])

  return (
    <div className={classes.root}>
      {!isLoading && (
        <>
          <HMapDetailsEditPanelContent
            id={mapForEditRef.current}
            dynamicFieldsRef={dynamicFieldsRef}
            operationsRef={operationsRef}
            allHeatMaps={allHeatMaps}
            onChange={handleOnChange}
            readonly={false}
            formFields={formFields}
          />
          <HMapDetailsFooter
            text={'Save Heatmap'}
            onCanel={goToTabPanel}
            onSubmit={submitHeatMap}
          />
        </>
      )}
    </div>
  )
}

export default React.memo(HMapDetailsEditPanel)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  }
}))
